import { QRCodeData } from '../types/QRCodeData';

/**
 * Generates QR code content string from barcode.
 *
 * The QR code contains ONLY the barcode string.
 * No JSON, no additional data - just the barcode.
 *
 * @param barcode - The barcode string to encode
 * @returns The barcode string (passed through)
 *
 * @example
 * const qrContent = generateQRCodeContent('ABC123456');
 * // Returns: 'ABC123456'
 */
export function generateQRCodeContent(barcode: QRCodeData): string {
    return barcode || '';
}

/**
 * Parses QR code content string back to barcode.
 *
 * Since the QR code contains only the barcode string,
 * this just returns the content as-is.
 *
 * @param content - The string from QR code scan
 * @returns The barcode string
 *
 * @example
 * const barcode = parseQRCodeContent('ABC123456');
 * // Returns: 'ABC123456'
 */
export function parseQRCodeContent(content: string): QRCodeData {
    return content;
}
